module.exports = __webpack_public_path__ + "assets/img/newsIcon1.a41650b2.png";